// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Applicative_Extra from "../Control.Applicative.Extra/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Restaumatic_Address from "../Restaumatic.Address/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic_Order_Types from "../Restaumatic.Order.Types/index.js";
import * as Restaumatic_Prelude_Specular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic_Services_Delivery from "../Restaumatic.Services.Delivery/index.js";
import * as Restaumatic_Site_Translations_Keys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_FRP_Async from "../Specular.FRP.Async/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
var deliveryStatusWidget = function (config) {
    return function (dmethod) {
        return function (dresult) {
            var methodToAddress = function (v) {
                if (v instanceof Restaumatic_Order_Types.DeliveryMethodPickup) {
                    return Data_Maybe.Nothing.value;
                };
                if (v instanceof Restaumatic_Order_Types.DeliveryMethodShipment) {
                    return new Data_Maybe.Just(Restaumatic_Address.formatAddressForDisplay(v.value0.address));
                };
                if (v instanceof Restaumatic_Order_Types.DeliveryMethodDineIn) {
                    return Data_Maybe.Nothing.value;
                };
                if (v instanceof Restaumatic_Order_Types.DeliveryMethodNoContactDelivery) {
                    return new Data_Maybe.Just(Restaumatic_Address.formatAddressForDisplay(v.value0.address));
                };
                throw new Error("Failed pattern match at Restaumatic.Site.Components.DeliveryStatus (line 75, column 5 - line 83, column 47): " + [ v.constructor.name ]);
            };
            var deliveryInProgress = Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("js-delivery-in-progress") ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.el("i")([ Specular_Dom_Element.class_("icon-spinner icon-spin") ])(Restaumatic_Prelude_Specular.wempty))(function () {
                return Specular_Dom_Element.text(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.delivery.checking_delivery));
            }));
            var deliveryError = function (method) {
                return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("alert alert-danger u-mb0") ])(Specular_Dom_Element.text(Restaumatic_I18n.translate(Restaumatic_Site_Translations_Keys.t.delivery.not_possible)({
                    address: Data_Maybe.fromMaybe("")(Control_Bind.bind(Data_Maybe.bindMaybe)(method)(methodToAddress))
                })));
            };
            var changeRestaurant = function (restaurantInfo) {
                return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("alert alert-warning") ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.text(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.delivery.change_restaurant)))(function () {
                    return Specular_Dom_Element.el("a")([ Specular_Dom_Element.class_("btn btn-warning"), Specular_Dom_Element.attr("data-ga-action")("Change restaurant with alternative link"), Specular_Dom_Element.attr("href")(restaurantInfo.path) ])(Specular_Dom_Element.text(restaurantInfo.restaurantName));
                }));
            };
            return Specular_FRP_Replaceable.dynamic_(Specular_Dom_Builder.monadReplaceBuilder)(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Control_Applicative_Extra.for2(Specular_FRP_Base.applyDynamic)(dmethod)(dresult)(function (method) {
                return function (result) {
                    if (result instanceof Specular_FRP_Async.NotRequested) {
                        return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Data_Unit.unit);
                    };
                    if (result instanceof Specular_FRP_Async.Loading) {
                        if (config.showLoading) {
                            return deliveryInProgress;
                        };
                        return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Data_Unit.unit);
                    };
                    if (result instanceof Specular_FRP_Async.Loaded && result.value0 instanceof Data_Either.Left) {
                        return deliveryError(Data_Maybe.Nothing.value);
                    };
                    if (result instanceof Specular_FRP_Async.Loaded && (result.value0 instanceof Data_Either.Right && result.value0.value0 instanceof Restaumatic_Services_Delivery.WontDeliver)) {
                        return deliveryError(method);
                    };
                    if (result instanceof Specular_FRP_Async.Loaded && (result.value0 instanceof Data_Either.Right && result.value0.value0 instanceof Restaumatic_Services_Delivery.ChangeRestaurant)) {
                        return changeRestaurant(result.value0.value0.value0);
                    };
                    if (result instanceof Specular_FRP_Async.Loaded && (result.value0 instanceof Data_Either.Right && result.value0.value0 instanceof Restaumatic_Services_Delivery.Ok)) {
                        return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Data_Unit.unit);
                    };
                    throw new Error("Failed pattern match at Restaumatic.Site.Components.DeliveryStatus (line 29, column 5 - line 49, column 18): " + [ result.constructor.name ]);
                };
            }));
        };
    };
};
export {
    deliveryStatusWidget
};
//# sourceMappingURL=index.js.map
